import { UnlockCaseConfig, UnlockCaseArgs } from './types';
import { getUserMessage } from 'app/infrastructure/notifications/user-messages/get-user-message';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { api } from './api';

const toasts = toastFactory();

export const UnlockPreset: { [key: string]: UnlockCaseConfig } = {
  case: {
    getLockedBy: async (caseNumber: number) => {
      try {
        return await api.getLockedBy(caseNumber);
      }
      catch (err) {
        toasts.dispatchError(getUserMessage(err.userMessages));
        return null;
      }
    },

    discardUnlockCase: async (
      args: Partial<UnlockCaseArgs>,
      translate: { [key: string]: string }
    ) => {
      try {
        await api.choosePersonUnlockCase({
          draftId: args?.draftId,
          personId: args?.personId
        } as UnlockCaseArgs);

        await api.discardUnlockCase(args?.draftId);

        toasts.dispatchInfo(replaceTemplateString(translate.unlock_case_discard_success, args?.caseId));
      } catch (err) {
        toasts.dispatchError(getUserMessage(err.userMessages)
          || replaceTemplateString(translate.unlock_case_fail, args?.caseId));
      }
    },

    choosePersonUnlockCase: async (
      args: Partial<UnlockCaseArgs>,
      translate: { [key: string]: string }
    ) => {
      try {
        await api.choosePersonUnlockCase({
          draftId: args?.draftId,
          personId: args.personId
        } as UnlockCaseArgs);
        toasts.dispatchInfo(
          replaceTemplateString(translate.unlock_case_person_success,
            args.personName,
            args?.caseId));
      } catch (err) {
        toasts.dispatchError(getUserMessage(err.userMessages)
          || replaceTemplateString(translate.unlock_case_fail, args?.caseId));
      }
    },
    getPersonOptions: async (caseId: number, filterText?: string) => {
      try {
        return await api.getPersonOptions(caseId, filterText);
      }
      catch (err) {
        toasts.dispatchError(getUserMessage(err.userMessages));
        return [];
      }
    }
  }
};
